import axios from "../../axios";
import { parseContentDispositionFilename } from "../../../utils/http";

const api = {
  getEmployeeCommutingItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/employee-commuting/items`,
      config).then(({ data }) => data);
  },

  addEmployeeCommutingItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/employee-commuting/items`, data, headers)
      .then(({ data }) => data);
  },

  updateEmployeeCommutingItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/employee-commuting/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteEmployeeCommutingItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/employee-commuting/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importEmployeeCommutingItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/employee-commuting/items/import`, data, headers).then(({ data }) => data);
  },

  getEmployeeCommutingTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${questionnaireId}/employee-commuting/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = parseContentDispositionFilename(
        headers["content-disposition"], "Scope3_Category7_template.xlsx");
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;